import classNames from 'classnames'
import * as React from 'react'

export interface ICalendarLegendEntryProps {
  entryKey: string
  entryDescription: string
}

export class CalendarLegendEntry extends React.PureComponent<
  ICalendarLegendEntryProps
> {
  public render() {
    return (
      <li className='calendar-legend-entry'>
        <div
          className={classNames(
            'calendar-legend-entry-block',
            this.props.entryKey,
          )}
        />
        {this.props.entryDescription}
      </li>
    )
  }
}
